import {
  Download as DownloadIcon,
  Pin as PinIcon,
  PinOff as PinOffIcon,
  Route as RouteIcon,
  SquarePlus as SquarePlusIcon,
} from '@lucide/vue'

import type { ActionMenuItem } from '@/components/ui/actionMenu'
import type { Tour, TourListItem } from '@/types/tour'

type TourPrimaryActionTour = Pick<Tour, 'clientId' | 'name' | 'isPinned'> | TourListItem

export interface TourPrimaryActionOptions {
  tour: TourPrimaryActionTour
  canEdit: boolean
  isActivity: boolean
  isDownloading?: boolean
  onTogglePinned: () => void
  onEditRoute: () => void
  onDownload: () => void
  onAddToCollection: () => void
}

export const buildTourPrimaryActionItems = ({
  tour,
  canEdit,
  isActivity,
  isDownloading = false,
  onTogglePinned,
  onEditRoute,
  onDownload,
  onAddToCollection,
}: TourPrimaryActionOptions): ActionMenuItem[] => {
  const items: ActionMenuItem[] = [
    {
      key: 'toggle-pinned',
      label: tour.isPinned ? 'Unpin' : 'Pin',
      icon: tour.isPinned ? PinOffIcon : PinIcon,
      iconClass: tour.isPinned ? 'text-amber-600' : 'text-gray-400',
      onSelect: onTogglePinned,
    },
  ]

  if (!isActivity && canEdit) {
    items.push({
      key: 'edit-route',
      label: 'Edit route',
      icon: RouteIcon,
      onSelect: onEditRoute,
    })
  }

  items.push(
    {
      key: 'download',
      label: 'Download GPX',
      icon: DownloadIcon,
      loading: isDownloading,
      onSelect: onDownload,
    },
    {
      key: 'add-to-collection',
      label: 'Add to collection',
      icon: SquarePlusIcon,
      onSelect: onAddToCollection,
    },
  )

  return items
}
